import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import useAsyncRemoveListContacts from '../../../../hooks/useAsyncRemoveListContacts';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { removeContact } from '../../../../store/conversationGrid';
import { useAppDispatch } from '../../../../store/hooks';
import ButtonLoading from '../../../Shared/ButtonLoading';

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        width: '100%',
    },
    btnCancel: {
        marginRight: theme.spacing(1),
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

interface Props {
    isOpen: boolean;
    contactIds: number[];
    listId: number;
    onCloseHandler: () => void;
}

export default function DialogRemoveGroupContacts({
    isOpen,
    contactIds,
    listId,
    onCloseHandler,
}: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const { requestStatus, asyncRemoveListContacts } = useAsyncRemoveListContacts();

    const handleSubmit = async () => {
        const asyncResult = await asyncRemoveListContacts(listId, contactIds);

        if (asyncResult) {
            /*
               At time of writing: it is reasonable to assume that if the call to remove contacts
               from a list is executed through this component, that the active conversation grid
               list is the target list.

               Remove contacts from the current conversation grid list on successful completion of the async call.
             */
            dispatch(removeContact({ contactId: contactIds }));

            onCloseHandler();
        }
    };

    return (
        <Dialog
            maxWidth="xs"
            aria-labelledby="dialog_remove_group_contact"
            open={isOpen}
            PaperProps={{
                className: classes.paper,
            }}
        >
            <DialogTitle id="dialog_remove_group_contact">Remove Group Contacts</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" align="center">
                    Contact will be removed from this contact group
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button className={classes.btnCancel} autoFocus onClick={onCloseHandler}>
                    Cancel
                </Button>
                <ButtonLoading
                    isLoading={requestStatus === RequestStatus.active}
                    onClick={handleSubmit}
                    color="secondary"
                    variant="outlined"
                >
                    Ok
                </ButtonLoading>
            </DialogActions>
        </Dialog>
    );
}
